import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Text,
  FormControl,
  FormLabel,
  Switch,
  useToast,
} from '@chakra-ui/react';

import { deleteSkuItemApi } from 'features/sku-management/sku-management.api';

const DeleteSkuModal = ({ isOpen, onClose, row, onDeleted }) => {
  const dispatch = useDispatch();
  const toast = useToast();
  const [endMarketplaceListings, setEndMarketplaceListings] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    if (!row?.id) return;
    setIsDeleting(true);
    const result = await dispatch(
      deleteSkuItemApi({
        skuMongoId: row.id,
        endMarketplaceListings,
      }),
    );
    setIsDeleting(false);

    if (deleteSkuItemApi.fulfilled.match(result)) {
      toast({
        title: 'SKU deleted',
        description: row.canonicalSku,
        status: 'success',
        duration: 4000,
        isClosable: true,
      });
      onClose();
      onDeleted?.();
    } else {
      toast({
        title: 'Delete failed',
        description: result.payload?.message || 'Could not delete SKU',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete SKU & listings</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text mb={4}>
            Permanently delete <strong>{row?.canonicalSku}</strong> and its catalog data?
            {(row?.listingsCount ?? 0) > 0 &&
              ` This SKU has ${row.listingsCount} linked listing(s).`}
          </Text>
          <FormControl display="flex" alignItems="center">
            <FormLabel mb={0} flex={1}>
              End listings on marketplace
            </FormLabel>
            <Switch
              isChecked={endMarketplaceListings}
              onChange={(e) => setEndMarketplaceListings(e.target.checked)}
              colorScheme="red"
            />
          </FormControl>
        </ModalBody>
        <ModalFooter gap={3}>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="red" onClick={handleDelete} isLoading={isDeleting}>
            Delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteSkuModal;
